import {ButtonAddTable} from "components/Button";
import {DashboardLayout} from "components/Layout";
import {ModalConfirmation} from "components/Modal";
import {BasicTable, SearchBox} from "components/Table";
import {useDeleteIndicatorReport, useIndicatorReport} from "hooks/SuperAdmin/Article";
import {useStateCallback} from "hooks/useStateCallback";
import {useToast} from "hooks/useToast";
import {truncate} from "lodash";
import moment from "moment";
import {useMemo, useState} from "react";
import {useHistory} from "react-router-dom";
import {convertErrorMessageFormat} from "utils/converter";

const SettingIndicatorReportListPage = () => {
	const [searchKeyword, setSearchKeyword] = useState("");
	const [dataLimit, setDataLimit] = useState(10);
	const {data, isLoading, setFilter} = useIndicatorReport();

	const {mutate, isLoading: isDeletingData} = useDeleteIndicatorReport();
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [deleteItemData, setDeleteItemData] = useStateCallback({id: null, name: null});
	const {showToast} = useToast();

	const history = useHistory();
	const columns = useMemo(
		() => [
			{
				Header: "No",
				accessor: "idSerial",
			},
			{
				Header: "Title",
				accessor: "title",
				Cell: ({row}) => <p>{truncate(row?.values?.title, {length: 33})}</p>,
			},
			{
				Header: "Created At",
				accessor: "createdAt",
				maxWidth: 150,
				Cell: ({row}) => <p>{moment(row?.values?.createdAt).format("DD/MM/YYYY")}</p>,
			},
			{
				Header: "Updated At",
				accessor: "updatedAt",
				maxWidth: 150,
				Cell: ({row}) => <p>{moment(row?.values?.updatedAt).format("DD/MM/YYYY")}</p>,
			},
			{
				Header: "Aksi",
				accessor: "id",
				Cell: ({row}) => (
					<>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => history.push(`/setting-indicator-report/detail/${row.values?.id}`)}>
							<span class="icon-ico-eye-open ft-18" />
						</a>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => history.push(`/setting-indicator-report/edit/${row.values?.id}`)}>
							<span class="icon-ico-pencil ft-18" />
						</a>
						<a
							class="text-orange wait-pay"
							style={{cursor: "pointer"}}
							onClick={() => {
								setDeleteItemData(row?.values, () => setShowDeleteModal(true));
							}}>
							<span class="icon-ico-delete ft-18" />
						</a>
					</>
				),
			},
		],
		[],
	);

	const dataWithIDSerial =
		data?.data?.rows?.map((item, index) => ({
			...item,
			idSerial: index + 1,
		})) || [];

	const handleDeleteData = () => {
		mutate(
			{id: deleteItemData.id},
			{
				onSuccess: () => {
					showToast(
						"success",
						`Data setting indicator report ${deleteItemData.title} berhasil dihapus`,
						3000,
					);
					window.scrollTo(0, 0);
					setShowDeleteModal(false);
				},
				onError: res => {
					showToast("error", convertErrorMessageFormat(res.response.status, res.response.data.message), null);
				},
			},
		);
	};

	return (
		<DashboardLayout>
			<ModalConfirmation
				approveLabel="Ya"
				description={`Apakah Anda yakin ingin menghapus data indicator report "${deleteItemData.title}"?`}
				loading={isDeletingData}
				rejectLabel="Batal"
				visible={showDeleteModal}
				onApprove={handleDeleteData}
				onClose={() => setShowDeleteModal(false)}
				onReject={() => setShowDeleteModal(false)}
			/>
			<div class="text-bold text-dark mb-4">Setting Indicator Report</div>
			<SearchBox
				rightElement={
					<ButtonAddTable
						text="Tambah Setting Indicator Report"
						onClick={() => history.push("/setting-indicator-report/tambah")}
					/>
				}
				onSearch={keyword => {
					setSearchKeyword(keyword);
					setFilter({page: 1, limit: dataLimit, search: keyword});
				}}
			/>
			<BasicTable
				columns={columns}
				currentPage={data?.data?.currentPage}
				data={dataWithIDSerial}
				limit={dataLimit}
				loading={isLoading}
				striped={true}
				title="Data Setting Indicator Report"
				totalItems={data?.data?.totalItems}
				totalPage={data?.data?.totalPages}
				onLimitChange={limitValue => {
					setDataLimit(limitValue);
					setFilter({page: 1, limit: limitValue, search: searchKeyword});
				}}
				onPageChange={selectedPage => setFilter({page: selectedPage, limit: dataLimit, search: searchKeyword})}
			/>
		</DashboardLayout>
	);
};

export {SettingIndicatorReportListPage};
